export default {
  path: 'processing',
  name: 'processing',
};
